// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landing-container{
    display: flex;
    flex-direction: column;
    background: #111111;
    justify-content: center; /* horizontal */
    align-items: center;
    height: 100vh;
    padding-top: 0px;
    gap: 16px;
}

.button{
    background: #1CD66A;
    border-radius: 90px;
    width: 300px;
    height: 100px;
    font-size: 24px;
    font-weight: bold;
}

h1 {
    color: #FFFFFF;
    display: flex;
    font-size: 96px;
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/landing.css"],"names":[],"mappings":"AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB,EAAE,eAAe;IACxC,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,eAAe;IACf,kBAAkB;AACtB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600&display=swap');\n\n.landing-container{\n    display: flex;\n    flex-direction: column;\n    background: #111111;\n    justify-content: center; /* horizontal */\n    align-items: center;\n    height: 100vh;\n    padding-top: 0px;\n    gap: 16px;\n}\n\n.button{\n    background: #1CD66A;\n    border-radius: 90px;\n    width: 300px;\n    height: 100px;\n    font-size: 24px;\n    font-weight: bold;\n}\n\nh1 {\n    color: #FFFFFF;\n    display: flex;\n    font-size: 96px;\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
